import React, {useEffect, useState} from 'react';
import styled from 'styled-components';
import ReactDelighters from 'rev.sdk.js/Components/ReactDelighters';
import {useOutlet} from 'reconnect.js';
import * as JStorage from 'rev.sdk.js/Actions/JStorage';
import SiteNavBar from '../../Components/SiteNavBar';
import BannerCarousel from './BannerCarousel';
import News from './News';
import ProductsCat from './ProductsCat';
import Features from './Features';
import Blogs from './Blogs';
import AboutPinbar from './AboutPinbar';
import ProductsSpecials from './ProductsSpecials';

function Landing(props) {
  const [landing] = useOutlet('landing');
  const [categories] = useOutlet('categories');
  const [specials, setSpecials] = useState([]);
  const [articles, setArticles] = useState([]);
  const [actions] = useOutlet('actions');

  useEffect(() => {
    const _fetchSpecials = async () => {
      const resp = await JStorage.fetchDocuments('product', {
        labels: {
          $in: ['specials'],
        },
      });
      setSpecials(resp.results);
    };
    const _fetchArticles = async () => {
      const resp = await JStorage.fetchDocuments('Article_Default', {
        label: {
          $in: ['blog', 'news'],
        },
      });
      setArticles(resp.results);
    };

    const _fetchHomeResource = async () => {
      try {
        actions.setLoading(true);
        await _fetchSpecials();
        await _fetchArticles();
      } catch (e) {
        console.log('debug', e);
      } finally {
        actions.setLoading(false);
      }
    };
    _fetchHomeResource();
  }, [actions]);

  const {banners = []} = landing;

  return (
    <ReactDelighters>
      <SiteNavBar />
      <Wrapper hasNavbar={true}>
        <BannerCarousel banners={banners} />
        <News news={articles.filter((a) => a.label.includes('news'))} />
        <div
          style={{
            backgroundColor: '#ccc',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <ProductsCat categories={categories} />
          <ProductsSpecials specials={specials} />
        </div>
        <Features />
        <Blogs blogs={articles.filter((a) => a.label.includes('blog'))} />
        <AboutPinbar />
      </Wrapper>
    </ReactDelighters>
  );
}

const Wrapper = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;

  margin-top: ${({hasNavbar}) =>
    hasNavbar ? `var(--topNavBarHeight)` : `0px`};

  & > section {
    position: relative;
    overflow-x: hidden;
  }

  & .landing-fade {
    opacity: 0;
    transition: 350ms;
  }

  & .landing-fade.delighter.started {
    opacity: 1;
  }

  & .landing-zoom {
    opacity: 0;
    transform: scale(0);
    transition: 350ms;
  }

  & .landing-zoom.delighter.started {
    opacity: 1;
    transform: scale(1);
  }

  & .landing-slide-up {
    opacity: 0;
    transform: translateY(200px);
    transition: 200ms;
  }

  & .landing-slide-up.delighter.started {
    opacity: 1;
    transform: translateY(0px);
  }

  & .landing-slide-in-right {
    opacity: 0;
    transform: translateX(500px);
    transition: 250ms;
  }

  & .landing-slide-in-right.delighter.started {
    opacity: 1;
    transform: translateX(0px);
  }

  & .landing-slide-in-left {
    opacity: 0;
    transform: translateX(-500px);
    transition: 250ms;
  }

  & .landing-slide-in-left.delighter.started {
    opacity: 1;
    transform: translateX(0px);
  }

  & h2 {
    font-size: 32px;
  }

  & p {
    font-size: 18px;
  }
`;

export default Landing;
